"use client";

import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
import Faqs from "@/components/faq/Faq";
import Sidebar from "@/components/sideBar/SideBar";
import "./style.css";
import CommonBanner from "@/components/commonBanner/CommonBanner";
export default function AboutUsClientPage() {
  return (
    <div className="gh-container top-header-page-padding">
      <Breadcrumbs
        items={[{ label: "Home", href: "/" }, { label: "About Us" }]}
      />

      <div className="post-head gh-container mt-3">
        <div className="post-head-wrapper">
          <picture>
            <img
              src="/about.png"
              alt="About us | coinccino"
              className="post-feature-image"
              data-categories="unclassified"
            />
          </picture>

          <CommonBanner
            authorSlug="riccardocuratolo"
            authorImageSrcSetWebp="/about-small.png"
            authorImageSrcSet="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp 200w, https://cdn.coinccinos.com/content/images/size/w100/2024/12/Riccardo-Curatolo.webp 100w"
            authorImage="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp"
            authorName="Riccardo Curatolo"
            dateISO="2022-12-07"
            dateLabel="Dec 7, 2022"
            readTime="9 min read"
            title="About Us"
            excerpt="Coinccino is an emerging news and media platform where we are
                committed to deliver the latest updates, in-depth analysis, and
                expert insights from the fast-paced world of cryptocurrencies.
                Whether a seasoned trader, a blockchain enthusiast, or just a
                curious-head in the crypto space, Coinccino publishes reliable
                information and engaging content for everyone"
            facebookUrl="https://en.coinccinos.com/about/"
            twitterUrl=""
          />
        </div>
      </div>
      <div className="gh-container post-main-wrapper with-sidebar">
        <div className="row gap-2">
          {/* Main Content Column */}
          <div className="col-lg-8 col-md-7 post-page-main">
            <div className="post-content with-sidebar">
              <h2 id="vision">Vision</h2>

              <p>
                At Coinccino, we believe in the power of knowledge. Our team of
                dedicated writers, analysts, and industry experts work around
                the clock to share the most relevant and timely news. We cover
                everything from the market trends to regulatory developments and
                new technologies to innovative projects being launched in this
                field. But that's not all! Coinccino is more of a community — a
                global network of crypto enthusiasts who share a passion for the
                future of finance. We foster a space where ideas can flourish,
                discussions can thrive, and everyone can learn and grow
                regardless of their experience level.
              </p>

              <p>
                Join Coinccino on social media channels and let's connect to
                keep all informed about "what's happening in the crypto world!"
              </p>

              <p>
                We would always love to hear your thoughts, go to Contact Us if
                you want to connect with our team.
              </p>
              <div className="d-flex">
                <Faqs />
              </div>
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="col-lg-6 col-md-5">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  );
}
